import { Modal, Box, Typography, Button, Grid, List, ListItem, ListItemIcon, ListItemText, Divider } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { InfoOutlined } from '@mui/icons-material';

interface GrupoErros {
  titulo: string;
  mensagem: string[];
}

interface ModalMensagemProps {
  open: boolean;
  dados: GrupoErros[];
  mensagem?: string;
  onClose: () => void;
  textoBotao?: string;
}

export default function ModalMensagem({
  mensagem,
  open,
  dados,
  onClose,
  textoBotao = 'OK',
}: ModalMensagemProps) {

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: '#ffffff',
          borderRadius: 2,
          boxShadow: 1,
          width: { xs: 'calc(100% - 22px)', sm: 320 },
          maxWidth: 320,
          maxHeight: '80vh',
          overflowY: 'auto',
          outline: 'none',
          color: '#334155',
          fontWeight: 500,
          '& *': { fontWeight: 500 },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.2,
            px: 2,
            py: 1.6,
          }}
        >

          <Box
            sx={{
              width: 30,
              height: 30,
              borderRadius: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#dbeafe',
              color: '#0965c1',
              flexShrink: 0,
            }}
          >
            <InfoOutlined sx={{ fontSize: 18 }} />
          </Box>

          <Typography
            variant="h6"
            sx={{
              fontSize: 17,
              color: '#334155',
              fontWeight: 500,
              lineHeight: 1.2,
              marginBottom: -0.3,
            }}
          >
            {mensagem}
          </Typography>
        </Box>

        <Divider sx={{ width: '100%', marginBottom: 0.6, marginTop: -0.5 }} />

        <Grid container direction="column" spacing={0} sx={{ px: 2, pb: 0, pt: 0.8 }}>
          {dados.map((grupo, index) => (
            <Grid item key={index}>
              <Box
                sx={{ px: 1 }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: '#334155',
                    fontSize: 14,
                    fontWeight: 500,
                    mb: 0.4,
                  }}
                >
                  {grupo.titulo}
                </Typography>
                <Divider sx={{ width: '100%', marginBottom: 1, marginTop: -0.4 }} />

                <List dense sx={{ py: -4, }}>
                  {grupo.mensagem.map((msg, i) => (
                    <ListItem key={i} sx={{ py: 0, minHeight: '24px', px: 0.4, alignItems: 'flex-start' }}>
                      <ListItemIcon sx={{ minWidth: 24, mt: '-7px' }}>
                        <InfoOutlined sx={{ color: '#f59e0b', fontSize: 16 }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={msg}
                        primaryTypographyProps={{ fontSize: 13, fontWeight: 500, color: '#334155', sx: { mt: '-10px' } }}
                      />
                    </ListItem>
                  ))}
                </List>

              </Box>
            </Grid>
          ))}
        </Grid>

        <Box
          textAlign="right"
          sx={{
            px: 2,
            py: 1.5,
            marginTop: -3,
            backgroundColor: '#f8fbff',
          }}
        >
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              fontSize: 12,
              fontWeight: 500,
              py: 0.6,
              px: 2,
              textTransform: 'none',
              textAlign: 'center',
              lineHeight: 1,
              transform: 'translateY(-1px)',
              borderRadius: 1,
              backgroundColor: '#0965c1',
              '&:hover': { backgroundColor: '#0753a0' },
            }}
          >
            {textoBotao}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
